// extracted by mini-css-extract-plugin
module.exports = {"TechnologyTitle":"TechnologyTitle_TechnologyTitle__Pl9LA","TechnologyTitle__icon":"TechnologyTitle_TechnologyTitle__icon___rh_S"};